import { useState } from 'react'
import useFollow from '../hooks/useFollow'
import InstallGuideModal from './InstallGuideModal'
import { track } from '../lib/events'

export default function FollowButton({ teamId, vapidPublicKey }) {
  const { status, follow, unfollow } = useFollow(teamId, vapidPublicKey)
  const [showGuide, setShowGuide] = useState(false)

  if (status === 'unsupported') return null
  if (status === 'denied') {
    return (
      <span className="follow-hint">
        Notificações bloqueadas — ative-as nas definições do navegador.
      </span>
    )
  }
  if (status === 'needs-install') {
    function openGuide() {
      track('team-follow-clicked', { teamId })
      track('ios-install-guide-opened', { teamId })
      setShowGuide(true)
    }

    return (
      <>
        <button className="follow-btn" onClick={openGuide}>🔔 Seguir equipa</button>
        {showGuide && <InstallGuideModal onClose={() => setShowGuide(false)} />}
      </>
    )
  }

  const following = status === 'following'
  function toggleFollow() {
    if (following) return unfollow()
    track('team-follow-clicked', { teamId })
    return follow()
  }

  return (
    <button
      className={`follow-btn${following ? ' following' : ''}`}
      disabled={status === 'busy'}
      aria-pressed={following}
      onClick={toggleFollow}
    >
      {following ? '✓ A seguir' : '🔔 Seguir equipa'}
    </button>
  )
}
